var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-document"},[_c('div',{staticClass:"tg-document--title",class:_vm.titleClass},[_c('i',{staticClass:"tg-icon tg-icon-info"}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"tg-document--content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }